const search = window.location.search;
export default function (route) {
  return `${route}${search}`;
}